import { TermsText } from 'components/Policies'
import React from 'react'
import { ReactFC } from 'types'
import { TextPage } from './TextPage'


export const TermsPage: ReactFC = () => {
  return (
    <TextPage>
      <TermsText />
    </TextPage>
  )
}

export default TermsPage
